export default "__VITE_ASSET__SCY6M2j___"